import {DEFAULT_QUERY, loadAgencyStream, loadUserStream, updateReferenceCompanyCmd, updateReferenceUserCmd} from './actions'
import {BILLING_TYPES} from './models'

function agencyCriteriaUpdated() {
    var criteria

    return (state, dispatch) => {
        const nextCriteria = state.company.agency.criteria

        if (criteria === undefined) {
            // state initial value
            criteria = nextCriteria
        }

        if (nextCriteria != criteria) {
            dispatch(loadAgencyStream({...DEFAULT_QUERY, ...nextCriteria}))
            criteria = nextCriteria
        }
    }
}

function userCriteriaUpdated() {
    var criteria

    return (state, dispatch) => {
        const nextCriteria = state.company.user.criteria

        if (criteria === undefined) {
            // state initial value
            criteria = nextCriteria
        }

        if (nextCriteria != criteria) {
            dispatch(loadUserStream({...DEFAULT_QUERY, ...nextCriteria}))
            criteria = nextCriteria
        }
    }
}

function referenceCompanyCmdUpdated() {
    var cmd

    return (state, dispatch) => {
        const nextCmd = state.company.referenceCompanyCmd

        if (nextCmd != cmd) {

            if (nextCmd && nextCmd.commandType != (cmd && cmd.commandType)) {
                switch(nextCmd.commandType) {
                    case 'CreateClientAccount':
                    case 'CreateClientAccountHolding':
                        dispatch(updateReferenceCompanyCmd({billingType: nextCmd.billingType || BILLING_TYPES[0]}))
                        break
                    case 'CreateCallCenter':
                        dispatch(updateReferenceCompanyCmd({callCenterReference: null, billingType: null}))
                        break
                }
            }
            cmd = nextCmd
        }
    }
}

function referenceUserCmdUpdated() {
    var cmd

    return (state, dispatch) => {
        const nextCmd = state.company.referenceUserCmd

        if (nextCmd != cmd) {

            if (nextCmd && nextCmd.commandType != (cmd && cmd.commandType)) {
                switch(nextCmd.commandType) {
                    case 'ReferenceCallCenterUser':
                    case 'ReferenceCallCenterOperator':
                    case 'ReferenceClientAccountManager':
                        dispatch(updateReferenceUserCmd({managedAgencies: null, managedPatrimonies: null}))
                        break
                    case 'ReferenceExecutive':
                        dispatch(updateReferenceUserCmd({managedPatrimonies: null}))
                        break
                    case 'ReferencePatrimonyManager':
                        dispatch(updateReferenceUserCmd({managedAgencies: null}))
                        break
                }
            }
            cmd = nextCmd
        }
    }
}

export default [agencyCriteriaUpdated(), userCriteriaUpdated(), referenceCompanyCmdUpdated(), referenceUserCmdUpdated()]


// WEBPACK FOOTER //
// ./lib/company/actors.js